import { render, staticRenderFns } from "./ValueCard.vue?vue&type=template&id=3a9443c6&scoped=true"
import script from "./ValueCard.vue?vue&type=script&lang=js"
export * from "./ValueCard.vue?vue&type=script&lang=js"
import style0 from "./ValueCard.vue?vue&type=style&index=0&id=3a9443c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9443c6",
  null
  
)

export default component.exports